import { Context } from '@nuxt/types'
import { broadcasterSelectUrl } from '~/assets/ts/utils/urls'
import {
  GetServerCookie,
  LinkedBroadcasterCookie,
} from '~/assets/ts/utils/cookies'
import { BroadcasterApi } from '~/apiclient/apibroadcasters'
import { AllBroadcasterRoles, BroadcasterRoles } from '~/models/users/roles'
import { hasBroadcasterRoleOrIsAdmin } from '~/assets/ts/utils/dashboard'

function dashboardInvalidPermissionError(
  context: Context,
  broadcasterID: string
) {
  context.error({
    statusCode: 403,
    message: `You do not have permission to access this page. Contact an admin for ${broadcasterID} if you believe this is a mistake`,
  })
}

function redirectToSelectPage(context: Context) {
  context.$redirectTo(context.localePath(broadcasterSelectUrl(context)))
}

export default function dashboardAuth(roles?: BroadcasterRoles[]) {
  return async (context: Context) => {
    const broadcasterID = GetServerCookie(LinkedBroadcasterCookie, context)
    const broadcaster = context.store.getters['dashboard/broadcaster'] as
      | BroadcasterApi
      | undefined

    if (broadcaster?.broadcasterID === broadcasterID) {
      // Broadcaster in store matches sign in attempt
      if (hasBroadcasterRoleOrIsAdmin(context, roles)) {
        /* return */
      } else if (hasBroadcasterRoleOrIsAdmin(context, AllBroadcasterRoles)) {
        dashboardInvalidPermissionError(context, broadcasterID)
      } else {
        redirectToSelectPage(context)
      }
    } else {
      // Broadcaster in store does not match sign in attempt
      // eslint-disable-next-line no-lonely-if
      if (hasBroadcasterRoleOrIsAdmin(context, roles, broadcasterID)) {
        await context.store.dispatch('dashboard/fetchBroadcaster', {
          broadcasterID,
        })
      } else if (
        hasBroadcasterRoleOrIsAdmin(context, AllBroadcasterRoles, broadcasterID)
      ) {
        await context.store.dispatch('dashboard/fetchBroadcaster', {
          broadcasterID,
        })
        dashboardInvalidPermissionError(context, broadcasterID)
      } else {
        redirectToSelectPage(context)
      }
    }
  }
}
